module.exports = __webpack_public_path__ + "img/energy3.01ffb10f.jpg";